import { useEffect, useState } from 'react';
import PostCampaignBillingAudit from '../../services/adapters/campaignBillingAudit';
import { CampaignBillingAudit as CampaignBillingAuditType } from '../../types/campaigns.type';

interface CampaignBillingAuditProps {
  refreshTrigger: number;
  organisationDisplayName: string;
}

export default function CampaignBillingAudit({ refreshTrigger, organisationDisplayName }: CampaignBillingAuditProps) {
  const [auditData, setAuditData] = useState<CampaignBillingAuditType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const adapter = new PostCampaignBillingAudit();
        const response = await adapter.adaptResponse({ organisationDisplayName });
        setAuditData(response);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch audit details');
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [refreshTrigger, organisationDisplayName]);

  if (loading) {
    return (
      <div className="border border-pipgrey-light rounded-md p-4">
        <p className="text-sm text-secondary">Loading allowance change log...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="border border-pipgrey-light rounded-md p-4">
        <p className="text-sm text-red-600">{error}</p>
      </div>
    );
  }

  return (
    <div className="border border-pipgrey-light rounded-md overflow-hidden p-2">
      <h3 className="m-2 font-nunito">
        Allowance change log:
        {' '}
        {organisationDisplayName}
      </h3>
      <div className="h-100 m-2 overflow-y-auto">
        <table className="w-full">
          <thead className="bg-pipgrey-light sticky top-0">
            <tr>
              <th className="text-left px-3 py-2 font-medium text-sm">Channel</th>
              <th className="text-left px-3 py-2 font-medium text-sm">Change Amount</th>
              <th className="text-left px-3 py-2 font-medium text-sm">Changed By</th>
              <th className="text-left px-3 py-2 font-medium text-sm whitespace-nowrap">Changed At</th>
            </tr>
          </thead>
          <tbody>
            {auditData.map((row, index) => (
              <tr
                key={`${row.id}`}
                className={`border-b border-pipgrey-light ${
                  index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                }`}
              >
                <td className="px-3 py-1.5 text-sm">{row.channelName}</td>
                <td className="px-3 py-1.5 text-sm">
                  {row.changeAmount > 0 ? '+' : ''}
                  {row.changeAmount.toLocaleString()}
                </td>
                <td className="px-3 py-1.5 text-sm">{row.changedBy}</td>
                <td className="px-3 py-1.5 text-sm whitespace-nowrap">{row.changedAt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
